import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

export interface DirtyMessageFlowContextType {
  isDirty: boolean;
  setIsDirty: (v: boolean) => void;
}

export const DirtyMessageFlowContext = createContext<DirtyMessageFlowContextType | undefined>(
  undefined,
);

interface IProps {
  children: ReactNode;
}

export const DirtyMessageFlowProvider = ({ children }: IProps) => {
  const [isDirty, setIsDirty] = useState<boolean>(false);

  const value = useMemo(
    () => ({
      isDirty,
      setIsDirty,
    }),
    [isDirty],
  );

  return (
    <DirtyMessageFlowContext.Provider value={value}>{children}</DirtyMessageFlowContext.Provider>
  );
};

export const useDirtyMessageFlow = () => {
  const context = useContext(DirtyMessageFlowContext);
  if (context === undefined) {
    throw new Error('useDirtyMessageFlow must be used within a DirtyMessageFlowProvider');
  }
  return context;
};
